[
  "126.com",
  "163.com",
  "aim.com",
  "aol.com",
  "att.net",
  "bellsouth.net",
  "bt.com",
  "btinternet.com",
  "charter.net",
  "comcast.net",
  "compuserve.com",
  "cox.net",
  "daum.net",
  "earthlink.net",
  "fastmail.com",
  "fastmail.fm",
  "gmail.com",
  "gmx.com",
  "gmx.de",
  "gmx.net",
  "googlemail.com",
  "hanmail.net",
  "hotmail.com",
  "hushmail.com",
  "icloud.com",
  "juno.com",
  "libero.it",
  "live.com",
  "live.co.uk",
  "mac.com",
  "mail.ru",
  "mailfence.com",
  "me.com",
  "msn.com",
  "naver.com",
  "netzero.net",
  "orange.fr",
  "outlook.co.uk",
  "outlook.com",
  "proton.me",
  "protonmail.com",
  "qq.com",
  "sbcglobal.net",
  "sky.com",
  "t-online.de",
  "talktalk.net",
  "tin.it",
  "tuta.com",
  "tutanota.com",
  "verizon.net",
  "virginmedia.com",
  "wanadoo.fr",
  "web.de",
  "yahoo.com",
  "yandex.com",
  "yandex.ru",
  "yeah.net"
]
